import { GraphQLErrors } from '@apollo/client/errors';

export const UNAUTHENTICATED_CODE = 'UNAUTHENTICATED';

const isUnauthenticatedStatusInResponse = (graphQLErrors: GraphQLErrors) =>
    graphQLErrors.some(error => {
        const { extensions: { code = '' } = {} } = error ?? {};
        return code === UNAUTHENTICATED_CODE;
    });

export { isUnauthenticatedStatusInResponse };
